// @flow
import { abbreviateNumber, numberWithCommas } from 'omega-rtc/utils/metric-utils';
import { calculateYLabelGap, getTotalMetricLabel } from './utils';
import React, { Component } from 'react';
import 'chartjs-plugin-datalabels';
import { HorizontalBar } from '@reactchartjs/react-chart.js';
import { GMV_KEY } from 'omega-rtc/constants/metrics';

const getChartOptions = (yLabelGap: number, totalList: Array<number>, attributedDataKey: string, selectedVertical: string, distinctUserCountArray: Array<number>, currencyVal: string, metricType: string) => {
  return {
    tooltips: {
      callbacks: {
        label({ index }) {
          return (
            `No. of users: ${numberWithCommas(distinctUserCountArray[index])}. ${getTotalMetricLabel(selectedVertical, attributedDataKey, metricType)} ${attributedDataKey === GMV_KEY ? ` ${currencyVal}` : ''} ${numberWithCommas(Math.round(totalList[index]))}`
          );
        },
      },
    },
    legend: {
      display: false,
    },
    plugins: {
      legend: {
        position: 'right',
      },
      elements: {
        bar: {
          borderWidth: 2,
        },
      },
      responsive: true,
      maintainAspectRatio: false,
      datalabels: { // for showing labels on top of each bar
        anchor: 'end',
        align: 'right',
        formatter(value) {
          return abbreviateNumber(value);
        },
      },
    },
    scales: {
      xAxes: [
        {
          maxBarThickness: 8,
          ticks: {
            beginAtZero: true,
            stepSize: yLabelGap,
            padding: 16,
          },
          gridLines: {
            drawBorder: false,
            color: '#F0EFEF',
            zeroLineColor: '#F0EFEF',
          },
        },
      ],
      yAxes: [
        {
          gridLines: {
            display: false,
          },
          ticks: {
            beginAtZero: true,
            padding: 16,
          },
        },
      ],
    },
    layout: {
      padding: {
        top: 20,
      },
    },
  };
};

type BusinessMetricChartProps = {
  chartData: any,
  valuesVerticalAttributeKey: Array<number>,
  attributedDataKey: string,
  selectedVertical: string,
  distinctUserCountArray: Array<number>,
  currencyVal: string,
  metricType: string,
  chartLabels: Array<string>,
  valuesAvgVerticalAttributeKey: Array<number>,
}

export class BusinessMetricChart extends Component {
  props: BusinessMetricChartProps;

  render() {
    const {
      valuesVerticalAttributeKey,
      attributedDataKey,
      selectedVertical,
      distinctUserCountArray,
      currencyVal,
      metricType,
    } = this.props;

    const yLabelGap = calculateYLabelGap(valuesVerticalAttributeKey, 10, 1.5);
    const options = getChartOptions(yLabelGap, valuesVerticalAttributeKey, attributedDataKey, selectedVertical, distinctUserCountArray, currencyVal, metricType);
    return (
      <HorizontalBar
        aspectRatio={3}
        data={this.props.chartData}
        options={options}
      />
    );
  }
}
